module.exports = __webpack_public_path__ + "img/part3-icon5-over.7b39d9bb.png";